export const ACCESS_TOKEN_KEY="access_token";
export const GIGYA_USER_KEY="gigyaUser";
export const SELECTED_LANGUAGE_KEY="selectedLanguage";
export const OFFLINE_POPUP_SHOWN_KEY="offlinePopupShown";